import * as React from "react";
import { useState, useEffect } from "react";
import SearchPane from "../SearchPane";
import api from "../../../api";
import SearchButton from "./SearchButton";
import "./style.css";
import { IDropdownOption, Stack, Dropdown } from "@fluentui/react";

interface Props {
    onSearch: (term: string, debitorNo: string) => void;
    query: { term?: string };
    debitorNo?: string;
}

const Search: React.FunctionComponent<Props> = props => {
    const [firstRun, setFirstRun] = useState(true);
   
    const [searchTerm, setSearchTerm] = useState(props.query.term || "");
    const [autoComplete, setAutoComplete] = useState([] as string[]);
 
    useEffect(() => {
        if (!firstRun) {
            if (searchTerm.length >= 4) {
                api.ProductAPI.autoComplete(searchTerm, props.debitorNo).then(
                    setAutoComplete
                );
            } else {
                setAutoComplete([]);
            }
        }
        setFirstRun(false);
    }, [searchTerm]);

    let timer = 0;
    const onSearchFieldValueChange = (searchTerm: string) => {
        clearTimeout(timer);
        timer = window.setTimeout(async () => {
            setSearchTerm(searchTerm);
        }, 500);
    };

    const onSearchValueSelected = (value: string, index: number) => {
        setSearchTerm(value);
    };

    const search = () => {
        props.onSearch(searchTerm, props.debitorNo ? props.debitorNo : "");
    };

   

    return (
        <div className="search__container">
            <Stack horizontal tokens={{ padding: 20, childrenGap: 10 }}>
              
                <Stack.Item>
                    <Stack horizontal tokens={{ childrenGap: 10 }}>
                        <Stack.Item grow>
                            <SearchPane
                                placeholder={""}
                                title={""}
                                value={searchTerm}
                                items={autoComplete}
                                onValueChange={onSearchFieldValueChange}
                                onValueSelected={onSearchValueSelected}
                            />
                        </Stack.Item>
                        <Stack.Item>
                            <SearchButton onClick={search} />
                        </Stack.Item>
                    </Stack>
                </Stack.Item>
            </Stack>
        </div>
    );
};

export default Search;
